import common from './common.json';
import globalNavigation from './globalNavigation.json';
import userProfileMenu from './userProfileMenu.json';
import downloadMobileAppModal from './downloadMobileAppModal.json';

export const es = {
  common,
  globalNavigation,
  userProfileMenu,
  downloadMobileAppModal,
};
